/* apps/viewer/src/app/header/header.component.scss */
.ori-elevation-z0 {
  box-shadow: var(--mat-app-elevation-shadow-level-0);
}
.ori-elevation-z1 {
  box-shadow: var(--mat-app-elevation-shadow-level-1);
}
.ori-elevation-z2 {
  box-shadow: var(--mat-app-elevation-shadow-level-2);
}
.ori-elevation-z3 {
  box-shadow: var(--mat-app-elevation-shadow-level-3);
}
.ori-elevation-z4 {
  box-shadow: var(--mat-app-elevation-shadow-level-4);
}
.ori-elevation-z5 {
  box-shadow: var(--mat-app-elevation-shadow-level-5);
}
.ori-elevation-z6 {
  box-shadow: var(--mat-app-elevation-shadow-level-6);
}
.ori-elevation-z7 {
  box-shadow: var(--mat-app-elevation-shadow-level-7);
}
.ori-elevation-z8 {
  box-shadow: var(--mat-app-elevation-shadow-level-8);
}
.ori-elevation-z9 {
  box-shadow: var(--mat-app-elevation-shadow-level-9);
}
.ori-elevation-z10 {
  box-shadow: var(--mat-app-elevation-shadow-level-10);
}
.ori-elevation-z11 {
  box-shadow: var(--mat-app-elevation-shadow-level-11);
}
.ori-elevation-z12 {
  box-shadow: var(--mat-app-elevation-shadow-level-12);
}
.ori-elevation-z13 {
  box-shadow: var(--mat-app-elevation-shadow-level-13);
}
.ori-elevation-z14 {
  box-shadow: var(--mat-app-elevation-shadow-level-14);
}
.ori-elevation-z15 {
  box-shadow: var(--mat-app-elevation-shadow-level-15);
}
.ori-elevation-z16 {
  box-shadow: var(--mat-app-elevation-shadow-level-16);
}
.ori-elevation-z17 {
  box-shadow: var(--mat-app-elevation-shadow-level-17);
}
.ori-elevation-z18 {
  box-shadow: var(--mat-app-elevation-shadow-level-18);
}
.ori-elevation-z19 {
  box-shadow: var(--mat-app-elevation-shadow-level-19);
}
.ori-elevation-z20 {
  box-shadow: var(--mat-app-elevation-shadow-level-20);
}
.ori-elevation-z21 {
  box-shadow: var(--mat-app-elevation-shadow-level-21);
}
.ori-elevation-z22 {
  box-shadow: var(--mat-app-elevation-shadow-level-22);
}
.ori-elevation-z23 {
  box-shadow: var(--mat-app-elevation-shadow-level-23);
}
.ori-elevation-z24 {
  box-shadow: var(--mat-app-elevation-shadow-level-24);
}
:host {
  height: 60px;
  transition: all 200ms linear;
  z-index: 20;
}
:host mat-toolbar {
  display: flex;
  flex-direction: row;
  height: 100%;
  justify-content: space-between;
  padding: 0 10px;
}
:host .left,
:host .right {
  display: flex;
  flex-direction: row;
}
:host .right {
  height: 100%;
}
:host .left {
  min-width: 0;
}
:host .left .du-title {
  display: flex;
  flex-direction: column;
  min-width: 0;
}
:host .left .du-title h3,
:host .left .du-title h4 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
:host .left .du-title h3 {
  font-size: 18px;
  margin: auto 0;
}
:host .left .du-title h4 {
  font-size: 17px;
  margin-top: -11px;
}
:host button,
:host o-history-switch,
:host o-historic {
  margin: auto 4px;
}
:host .synchro-icon {
  cursor: unset;
}
:host .beyblade {
  animation: rotate 2s infinite linear;
}
@media (max-width: 500px) {
  :host .left .du-title,
  :host .synchro-icon {
    display: none;
  }
  :host .left,
  :host .right {
    display: contents;
  }
}
@media print {
  :host {
    display: none;
  }
}
/*# sourceMappingURL=header.component.css.map */
